import React from "react";
import { Modal, ModalBody } from "reactstrap";
import local from "../../localization/strings";
import SiteSmsExplainer from "../admin-area/SiteSmsExplainer";
import SiteSmsLog from "../admin-area/SiteSmsLog";
import SmsAllowanceMeter from "./SmsAllowanceMeter";
import { smsAllowanceHeadline, smsAllowanceRemainingText, smsAllowanceTextClass } from "../../helpers/smsAllowance";

// The site's sent-SMS log for a site user, reached from the allowance chip in the header. The same
// table the admin area shows on its Sent Log tab, under the same balance and the same explanation of
// what the segments pay for, so an administrator and a site user looking at the same site read the
// same thing.
const SmsAllowanceLogModal = ({ isOpen, toggle, siteId, view }) => (
	<Modal isOpen={isOpen} toggle={toggle} centered backdrop="static" size="xl">
		<ModalBody>
			<span className="float-right close-modal" style={{ position: "absolute", top: 15, right: 20 }} onClick={toggle}>
				X
			</span>

			<div className="d-flex justify-content-between align-items-baseline mb-2 pr-4">
				<h4 className="mb-0">{local.TF_SmsAllowanceSentLog}</h4>
				{view && (
					<span className="fs--1 text-muted">
						{local.TF_SMS_Segments_Remaining}: <strong className="text-900">{view.remaining.toLocaleString()}</strong>
					</span>
				)}
			</div>

			{view && (
				<div className="mb-3">
					<SmsAllowanceMeter view={view} />
					<div className="fs--1 mt-1">
						<span className={`font-weight-semi-bold ${smsAllowanceTextClass(view.status)}`}>{smsAllowanceHeadline(view)}</span>
						<span className="text-muted"> · {smsAllowanceRemainingText(view)}</span>
					</div>
				</div>
			)}

			<SiteSmsExplainer />

			{/* Mounted only while open, so the log is not queried until somebody asks for it. */}
			{isOpen && <SiteSmsLog siteId={siteId} />}
		</ModalBody>
	</Modal>
);

export default SmsAllowanceLogModal;
